export default [{
  path: '/stage/settlementSuccess',
  name: 'stage-settlementSuccess',
  title: '结算成功',
  component: () => import('@/views/stage/template/settlementSuccess/index')
}];
